import { Observable } from "rxjs";
import { Patient } from "../patient-chart/patient";

export default class Activity {
  id: number;
  contactId: number;
  patientChartId: number;
  mileage: number;
  activityType: number;
  onCall: boolean;
  holiday: boolean;
  startTime: Date;
  endTime: Date;
  travelTime: number;
  duration: number;
  patientChart$: Observable<Patient>;
  timezone: string;
}



// WEBPACK FOOTER //
// ./src/models/company-resources/activity.ts